import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { conferimentoProdottiInvalidMessage, conferimentoServiziInvalidMessage } from '../common/consts/validation-message.const';
import { getSchedaPrevalenzaControl, schedaPrevalenzaCommHelper, schedaPrevalenzaValuesHelper } from './helpers/natura-mutualistica-form-validators.helper';

export const naturaMutualisticaSchedaPrevalenzaB6B7Rules: FormGroupRules = {
    my_B6confSociPrimoAnno: (form: FormGroup) => {
        const my_CkValoreQuantitaPrimoAnno: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_B6confSociPrimoAnno',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAttPrimoAnno',
            'my_TotaleB6PrimoAnno',
            'my_BilAnno1',
            'B6',
            conferimentoProdottiInvalidMessage,
            false,
            my_CkValoreQuantitaPrimoAnno === 'V'
        );
    },

    my_QtaConfSociPrimoAnno: (form: FormGroup) => {
        const my_CkValoreQuantitaPrimoAnno: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_QtaConfSociPrimoAnno',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAttPrimoAnno',
            'my_TotQtaConfSociPrimoAnno',
            'my_BilAnno1',
            'B6',
            conferimentoProdottiInvalidMessage,
            false,
            my_CkValoreQuantitaPrimoAnno === 'Q'
        );
    },

    my_B6confSoci: (form: FormGroup) => {
        const my_CkValoreQuantita: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_B6confSoci',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAtt',
            'my_TotaleB6',
            'my_BilAnno2',
            'B6',
            conferimentoProdottiInvalidMessage,
            false,
            my_CkValoreQuantita === 'V'
        );
    },

    my_QtaConfSoci: (form: FormGroup) => {
        const my_CkValoreQuantita: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_QtaConfSoci',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAtt',
            'my_TotQtaConfSoci',
            'my_BilAnno2',
            'B6',
            conferimentoProdottiInvalidMessage,
            false,
            my_CkValoreQuantita === 'Q'
        );
    },

    my_TotaleB6PrimoAnno: (form: FormGroup) => {
        const my_CkValoreQuantitaPrimoAnno: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleB6PrimoAnno',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAttPrimoAnno',
            null,
            'my_BilAnno1',
            'B6',
            conferimentoProdottiInvalidMessage,
            true,
            my_CkValoreQuantitaPrimoAnno === 'V'
        );
    },

    my_TotQtaConfSociPrimoAnno: (form: FormGroup) => {
        const my_CkValoreQuantitaPrimoAnno: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotQtaConfSociPrimoAnno',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAttPrimoAnno',
            null,
            'my_BilAnno1',
            'B6',
            conferimentoProdottiInvalidMessage,
            true,
            my_CkValoreQuantitaPrimoAnno === 'Q'
        );
    },

    my_TotaleB6: (form: FormGroup) => {
        const my_CkValoreQuantita: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleB6',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAtt',
            null,
            'my_BilAnno2',
            'B6',
            conferimentoProdottiInvalidMessage,
            true,
            my_CkValoreQuantita === 'V'
        );
    },

    my_TotQtaConfSoci: (form: FormGroup) => {
        const my_CkValoreQuantita: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita')?.value;
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotQtaConfSoci',
            'my_CkRemunConferProdSoci',
            'my_CkRemunConferProdSociCoopAtt',
            null,
            'my_BilAnno2',
            'B6',
            conferimentoProdottiInvalidMessage,
            true,
            my_CkValoreQuantita === 'Q'
        );
    },

    my_RemunConferProdSociCommPrimoAnno: (form: FormGroup) => {
        // In InfoPath le due errorCondition (modalità 'V' e 'Q') sono indipendenti sullo stesso campo con
        // lo stesso messaggio "Campo obbligatorio" (manifest.xsf, righe ~15047-15052). Chiamare
        // schedaPrevalenzaCommHelper due volte incondizionatamente farebbe sì che la seconda chiamata
        // (sempre falsa quando è attiva l'altra modalità) cancelli l'errore appena impostato dalla prima,
        // perché addRemoveError confronta i corpi errore per uguaglianza — qui identici. Una sola
        // modalità è attiva alla volta: basta invocare l'helper corrispondente a quella corrente.
        const my_CkValoreQuantitaPrimoAnno: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantitaPrimoAnno')?.value;
        if (my_CkValoreQuantitaPrimoAnno === 'V') {
            schedaPrevalenzaCommHelper(form, 'my_RemunConferProdSociCommPrimoAnno', undefined, 'my_B6confSociPrimoAnno', 'my_TotaleB6PrimoAnno', 'my_TotaleB6NonModifPrimoAnno');
        } else {
            schedaPrevalenzaCommHelper(
                form,
                'my_RemunConferProdSociCommPrimoAnno',
                undefined,
                'my_QtaConfSociPrimoAnno',
                'my_TotQtaConfSociPrimoAnno',
                'my_TotaleB6NonModifPrimoAnno',
                my_CkValoreQuantitaPrimoAnno === 'Q'
            );
        }
    },

    my_RemunConferProdSociComm: (form: FormGroup) => {
        const my_CkValoreQuantita: string = getSchedaPrevalenzaControl(form, 'my_CkValoreQuantita')?.value;
        if (my_CkValoreQuantita === 'V') {
            schedaPrevalenzaCommHelper(form, 'my_RemunConferProdSociComm', undefined, 'my_B6confSoci', 'my_TotaleB6', 'my_TotaleB6NonModif');
        } else {
            schedaPrevalenzaCommHelper(form, 'my_RemunConferProdSociComm', undefined, 'my_QtaConfSoci', 'my_TotQtaConfSoci', 'my_TotaleB6NonModif', my_CkValoreQuantita === 'Q');
        }
    },

    my_B7ricevSociPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_B7ricevSociPrimoAnno',
            'my_CkRemunPrestConfServSoci',
            'my_CkRemunPrestConfServSociCoopAttPrimoAnno',
            'my_TotaleB7PrimoAnno',
            'my_BilAnno1',
            'B7',
            conferimentoServiziInvalidMessage
        );
    },

    my_B7ricevSoci: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_B7ricevSoci',
            'my_CkRemunPrestConfServSoci',
            'my_CkRemunPrestConfServSociCoopAtt',
            'my_TotaleB7',
            'my_BilAnno2',
            'B7',
            conferimentoServiziInvalidMessage
        );
    },

    my_TotaleB7PrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleB7PrimoAnno',
            'my_CkRemunPrestConfServSoci',
            'my_CkRemunPrestConfServSociCoopAttPrimoAnno',
            null,
            'my_BilAnno1',
            'B7',
            conferimentoServiziInvalidMessage,
            true
        );
    },

    my_TotaleB7: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleB7',
            'my_CkRemunPrestConfServSoci',
            'my_CkRemunPrestConfServSociCoopAtt',
            null,
            'my_BilAnno2',
            'B7',
            conferimentoServiziInvalidMessage,
            true
        );
    },

    my_RemunPrestConfServSociCommPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(
            form,
            'my_RemunPrestConfServSociCommPrimoAnno',
            undefined,
            'my_B7ricevSociPrimoAnno',
            'my_TotaleB7PrimoAnno',
            'my_TotaleB7NonModifPrimoAnno'
        );
    },

    my_RemunPrestConfServSociComm: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(form, 'my_RemunPrestConfServSociComm', undefined, 'my_B7ricevSoci', 'my_TotaleB7', 'my_TotaleB7NonModif');
    },
};
